const billingAddress = {
  billingAddressAddressee: 'Charlie Doe',
  billingAddressLine1: '1640 Riverside Drive',
  billingAddressCity: 'Hill Valley',
  billingAddressState: 'CA',
  billingAddressPostalCode: '91103',
  billingAddressCountry: 'US',
} as const;

const cardDetails = {
  cardExpiresYear: '2026',
  cardExpiresMonth: '10',
  cardLast4: '4242',
} as const;

export const mockSubscriptions = [
  {
    _id: 1,
    productName: 'Bronze membership',
    variantPrice: {
      value: 10000,
      unit: 'USD',
    },
    variantImage: {
      url: 'https://source.unsplash.com/120x120/?science',
    },
    status: 'active',
    lastInvoiced: '2021-08-12T05:58:19.000Z',
    periodEnd: '2021-09-12T05:58:19.000Z',
    subCreatedOn: '2021-08-12T05:58:19.000Z',
    canceledOn: null,
    ...billingAddress,
    ...cardDetails,
  },
  {
    _id: 2,
    productName: 'Silver membership',
    variantPrice: {
      value: 25000,
      unit: 'USD',
    },
    variantImage: {
      url: 'https://source.unsplash.com/120x120/?electronics',
    },
    status: 'canceled',
    lastInvoiced: '2021-08-12T05:58:19.000Z',
    periodEnd: null,
    subCreatedOn: '2021-08-12T05:58:19.000Z',
    canceledOn: '2021-09-11T05:58:19.000Z',
    ...billingAddress,
    ...cardDetails,
  },
  {
    _id: 3,
    productName: 'Gold Membership',
    variantPrice: {
      value: 50000,
      unit: 'USD',
    },
    status: 'active',
    variantImage: {
      url: 'https://source.unsplash.com/120x120/?time',
    },
    lastInvoiced: '2021-08-12T05:58:19.000Z',
    subCreatedOn: '2021-08-12T05:58:19.000Z',
    periodEnd: '2021-09-12T05:58:19.000Z',
    canceledOn: null,
    ...billingAddress,
    ...cardDetails,
  },
] as const;

export const placeholderSubscription = {
  productName: '',
  variantPrice: {
    value: 0,
    unit: 'USD',
  },
  variantImage: {
    url: '',
  },
  status: '',
  lastInvoiced: '',
  periodEnd: '',
  subCreatedOn: '',
  canceledOn: '',
  billingAddressAddressee: '',
  billingAddressLine1: '',
  billingAddressCity: '',
  billingAddressState: '',
  billingAddressPostalCode: '',
  billingAddressCountry: '',
  cardExpiresYear: '',
  cardExpiresMonth: '',
  cardLast4: '',
} as const;
